export default __webpack_public_path__ + "static/media/error-icon.fb1f61d0.svg";